import { Controller } from "@hotwired/stimulus"

// Change-unit form: when the operator picks a different unit, prefill the rate
// field with that unit's street rate (still editable).
export default class extends Controller {
  static targets = ["unit", "rate"]

  prefill() {
    const option = this.unitTarget.selectedOptions[0]
    if (option && option.dataset.rate) this.rateTarget.value = option.dataset.rate
  }
}
